export const carouselGamesStep = {
    mobile: {
        portrait: 10,
        landscape: 12
    },
    tablet: {
        portrait: 15,
        landscape: 18
    }
};

export const pageGamesStep = {
    mobile: {
        portrait: 6,
        landscape: 9
    },
    tablet: {
        portrait: 13,
        landscape: 15
    }
};

export const carouselRenderingTemp = {
    mobile: 300,
    tablet: 300
};
